// breadcrumb.component.ts
import { Component } from '@angular/core';
import { BreadcrumbInterface } from './breadcrumb-interface';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatListItemIcon } from '@angular/material/list';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    imports: [MatIcon, MatListItemIcon, NgFor, NgIf, RouterLink]
})
export class BreadcrumbComponent {
  breadcrumbs: Array<BreadcrumbInterface> = [];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((): void => {
      this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    });
  }

  public createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    previousLabel: string = '',
    breadcrumbs: Array<BreadcrumbInterface> = []
  ): Array<BreadcrumbInterface> {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      const routeExist = this.routeExists(routeURL);
      if (routeExist && routeURL !== '') {
        url += `/${routeURL}`;
      }

      // - si data.breadcrumb est une fonction => on l'évalue avec le snapshot
      // - sinon on prend la valeur telle quelle
      const dataBreadcrumb = child.snapshot.data['breadcrumb'];
      let label: string | undefined;

      if (typeof dataBreadcrumb === 'function') {
        try {
          label = dataBreadcrumb(child.snapshot);
        } catch {
          label = undefined;
        }
      } else {
        label = dataBreadcrumb;
      }

      if (!label || label === '') {
        // Fallbacks si pas de data ou pas de fonction
        label = (history.state && history.state.breadcrumb) || child.snapshot.paramMap.get('uuid') || '';
      }

      if (label && label !== previousLabel) {
        // On évite les doublons de label dans le fil d'ariane'
        breadcrumbs.push({ label: label, url: url } as BreadcrumbInterface);
      }
      return this.createBreadcrumbs(child, url, label, breadcrumbs);
    }

    return breadcrumbs;
  }

  routeExists(path: string): boolean {
    return this.router.config.some((route): boolean => route.path === path);
  }
}
